// Логотип сущности: image == null → заглушка с кодом (сервер не шлёт пустых строк).
import { useState } from 'react';
import styles from './TeamLogo.module.css';

export function TeamLogo({ src, code, size = 24 }: { src: string | null | undefined; code?: string | null; size?: number }) {
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size };
  if (!src || failed) {
    return <span className={styles.placeholder} style={{ ...style, fontSize: size * 0.36 }} aria-hidden="true">
      {(code ?? '').replace(/[^\p{L}\p{N}]/gu, '').slice(0, 3)}
    </span>;
  }
  return <img className={styles.logo} style={style} src={src} alt="" loading="lazy" decoding="async"
    onError={() => setFailed(true)} />;
}
